import React, { useContext, useEffect, useState } from 'react';
import { RootContext } from '../context/beltContext';
import ChangeQuantity from '../hooks/changeQuantity';
import MinusCircle from "../svgs/minus-circle-solid.svg"
import PlusCircle from "../svgs/plus-circle-solid.svg"

const QuantityControl = ({ sku, callback = null, fromCart = false, fromSavedCart = false}) => {
    let { quantity, decreaseNum, increaseNum, updateNum, updateSku, setQuantity } = ChangeQuantity(sku, fromCart, fromSavedCart)
    let [qty, setQty] = useState(0);
    let { skus, updateSkus } = useContext(RootContext)

    useEffect(() => {
        updateSku(sku)
        if(skus[sku]){
            setQuantity(skus[sku].quantity)
        } else {
            if(!fromCart) return;
            let old = window.localStorage.getItem('cart');
            let cart = JSON.parse(old)
            let cartSku = cart[sku]
            let adjustedSkus = {...skus};
            adjustedSkus[sku] = { quantity: cartSku.qty, price: cartSku.price }
            updateSkus(adjustedSkus)
            setQuantity(cartSku.qty)
        }
        console.log('Quantity Control is updating ', skus)
    }, [sku, quantity, skus])

    const increase = async () => {
        let newPrice = await increaseNum(sku);
        callback(newPrice)
    }

    const decrease = async () => {
        let newPrice = await decreaseNum(sku);
        callback(newPrice)
    }

    const update = async (event) => {
        let newPrice = await updateNum(sku, event)
        callback(newPrice)
    }

    const enhancedContentSkus = [
        'vid',
        'deg',
        'doc',
        'fea',
        'com',
        'pto',
        'faq'
    ]

    return (
        <div className='mobile-quantity-amt'>
            {enhancedContentSkus.includes(sku)?
                <div className='text-muted my-auto me-auto mobile-cart'># of Modules</div>
                :
                <div className='text-muted my-auto me-auto mobile-cart'># of Items</div>
            }
            <div className='d-flex'>
            <MinusCircle className='text-primary plus-minus-circle my-auto ms-3 me-2 hover-pointer' onClick={decrease} />
            <input type="number" className="form-control no-input-arrows mobile-cart-item-height form-width" value={quantity} onChange={update} 
            // style={{ maxWidth: !!mobileRowWidth ? '55px': '65px' }} 
            />
            <PlusCircle className='text-primary plus-minus-circle my-auto ms-2 me-0 hover-pointer' onClick={increase} />
            </div>
        </div>
    )
}

export default QuantityControl;